var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 5.5H3V25.5H27V5.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2377_12",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 25,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6016 2.5H2.60156V26.5H26.6016V2.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2377_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6016 7.07895C12.947 7.07895 10.7801 9.07888 10.6571 11.5896C10.6365 12.0108 10.2737 12.3421 9.83299 12.3421H9.55156C7.72902 12.3421 6.25156 13.7559 6.25156 15.5C6.25156 17.2441 7.72902 18.6579 9.55156 18.6579H13.4856C13.4303 19.0011 13.4016 19.3525 13.4016 19.7105C13.4016 19.8876 13.4086 20.0632 13.4224 20.2368H9.55156C6.81775 20.2368 4.60156 18.1161 4.60156 15.5C4.60156 13.0331 6.57226 11.0066 9.08935 10.7835C9.60445 7.78619 12.3239 5.5 15.6016 5.5C18.8794 5.5 21.5987 7.7862 22.1138 10.7835C24.631 11.0066 26.6016 13.0331 26.6016 15.5C26.6016 15.6752 26.5917 15.8481 26.5723 16.0184C26.055 15.2475 25.3804 14.5824 24.5918 14.0647C24.0456 13.0421 22.9341 12.3421 21.6516 12.3421H21.3702C20.9296 12.3421 20.5667 12.0108 20.5461 11.5896C20.4231 9.07888 18.2561 7.07895 15.6016 7.07895ZM26.6016 19.7105C26.6016 22.908 23.893 25.5 20.5516 25.5C17.2102 25.5 14.5016 22.908 14.5016 19.7105C14.5016 16.5131 17.2102 13.9211 20.5516 13.9211C23.893 13.9211 26.6016 16.5131 26.6016 19.7105ZM24.2406 17.2331C24.0257 17.0276 23.6775 17.0276 23.4627 17.2331L19.4516 21.0715L17.6406 19.3383C17.4257 19.1328 17.0775 19.1328 16.8627 19.3383C16.6479 19.5439 16.6479 19.8772 16.8627 20.0827L19.0627 22.188C19.2775 22.3935 19.6257 22.3935 19.8406 22.188L24.2406 17.9775C24.4553 17.7719 24.4553 17.4386 24.2406 17.2331Z",
    fill: "#2B2B67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveCloud);
export default __webpack_public_path__ + "static/media/saveCloud.ab566b56817bd92fcf137f06cf97336f.svg";
export { ForwardRef as ReactComponent };